export default (file) => URL.createObjectURL(file);
